import { AdminUserActionType, apiBaseURL, toastTypes } from "../../../constant/index";
import { setLoading } from "../loadingAction";
import apiConfig from '@/config/apiConfig';
import { addTost } from "../toastAction";

export const fetchUsers = (currentPage) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await apiConfig.get(apiBaseURL.USERS + "?page=" + currentPage);
        dispatch({ type: AdminUserActionType.FETCH_USERS, payload: response.data?.data});
        // setAllUsers && setAllUsers(response.data?.data)
        dispatch(setLoading(false));
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(addTost({ type: toastTypes.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
        console.error('error', error);
    }
};

export const changeUserStatus = (status, checkedData) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await apiConfig.post(apiBaseURL.USERS + "/change-users-status?status=" + status, checkedData);
        dispatch(setLoading(false));
        dispatch(addTost({ type: toastTypes.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }));
        
        dispatch(fetchUsers(1));
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(addTost({ type: toastTypes.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
        console.error('error', error);
    }
};